export default "__VITE_ASSET__d129246e__"